<template>
  <div class="rank-list" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="rank-title" title="排行榜" />
    <img
      @click="goBack()"
      class="rank-reback"
      src="../../assets/selfSupport/backbefore@2x.png"
    />

    <van-row class="rank-top">
      <van-col class="rank-top-left box" span="9" v-if="list[1]">
        <div class="head-portrait">
          <img src="../../assets/member/No2.png" />
          <span class="avatar"
            ><img :src="list[1].head_pic" @error="nofind()"
          /></span>
        </div>
        <p class="nickname">{{ list[1].nickname }}</p>
        <p class="number">{{ list[1].count }}</p>
      </van-col>
      <van-col class="rank-top-right box" span="9" offset="6" v-if="list[2]">
        <div class="head-portrait">
          <img src="../../assets/member/No3.png" />
          <span class="avatar"
            ><img :src="list[2].head_pic" @error="nofind()"
          /></span>
        </div>
        <p class="nickname">{{ list[2].nickname }}</p>
        <p class="number">{{ list[2].count }}</p>
      </van-col>
      <van-col class="rank-top-middle" span="24" v-if="list[0]">
        <div class="No1 box">
          <div class="head-portrait">
            <img src="../../assets/member/No1.png" />
            <span class="avatar"
              ><img :src="list[0].head_pic" @error="nofind()"
            /></span>
          </div>
          <p class="nickname">{{ list[0].nickname }}</p>
          <p class="number">{{ list[0].count }}</p>
        </div>
      </van-col>
      <van-col span="24" class="tip" v-if="memberInfo.infos">
        <span v-if="rankShow && rank == 0"
          >您当前粉丝还未达到上榜要求，请再接再厉！</span
        >
        <span v-if="rankShow && rank != 0"
          >您当前处于{{ rank }}名，请再接再厉！</span
        >
      </van-col>
      <van-col span="24" class="myRank" v-if="memberInfo.infos">
        <p>
          <img :src="memberInfo.infos.head_pic" @error="nofind()" />{{
            memberInfo.nickname
          }}<span>{{ member_team }}</span>
        </p>
      </van-col>
    </van-row>
    <div class="fans-rank" v-if="list.length > 3">
      <p class="title">当前粉丝数</p>
      <van-row>
        <van-col
          span="24"
          v-for="(item, index) in list"
          :key="index"
          v-if="index > 2"
        >
          <span class="Ranking">{{ index + 1 }}</span
          ><img :src="item.head_pic" @error="nofind()" />{{ item.nickname
          }}<span>{{ item.count }}</span>
        </van-col>
        <van-col span="24" class="more">
          <p @click="getMore()">{{ tipWord }}</p>
        </van-col>
      </van-row>
    </div>
    <van-row class="Invitation">
      <van-col span="24">
        <p @click="toInvest()">邀请赚钱</p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import defaultImg from "@/assets/common/avatar.png";
export default {
  data() {
    return {
      list: [],
      isiOSX: false,
      flag: 0,
      tipWord: "点击加载更多",
      page: 1,
      pageSize: 10,
      allList: 11, //默认比每页数据多1
      memberInfo: {},
      member_team: 0,
      rank: 0,
      rankShow: false,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
    this.getInfo();
    this.currentInfo();
  },
  methods: {
    getMore() {
      if (this.flag == 0) {
        this.page++;
        this.getInfo();
      }
    },
    currentInfo() {
      this.$api
        .get("/member/member/user/detail")
        .then((res) => {
          this.member_team =
            Number(res.member_team.one) +
            Number(res.member_team.two) +
            Number(res.member_team.three) +
            Number(res.member_team.marchant);
          res.infos.head_pic = res.infos.head_pic || "aaa.png";
          this.memberInfo = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
      // this.$api.post("/member/member/member/get/top").then(res => {
      // 	this.rank = res.num;
      // 	this.rankShow = true;
      // }).catch(err => {
      //     let keys = Object.keys(err);
      //  	let key = keys[0];
      // 	let message = err.message || err[key][0]
      // 	if(message.slice(0, 10) == 'timeout of') {
      // 		this.$toast('网络不给力，请稍候重试');
      // 	}else {
      // 		this.$toast(message);
      // 	}
      // });
    },
    getInfo() {
      this.$api
        .post("/member/member/member/team/top", {
          pageSize: this.pageSize,
          page: this.page,
        })
        .then((res) => {
          this.rank = res.list.num;
          this.rankShow = true;
          this.allList = res.total;
          if (res.list[0].count) {
            for (var i = 0; i < 10; i++) {
              // for(let i in res.list) {
              if (res.list[i].count) {
                res.list[i].head_pic = res.list[i].head_pic || "aaa.png";
                var nickName = res.list[i].nickname;
                if (nickName == null) {
                  res.list[i].nickname = "***";
                } else {
                  res.list[i].nickname = this.nicknameHandle(nickName);
                }

                this.list.push(res.list[i]);
              }
            }
          }
          if (this.list.length >= this.allList) {
            this.tipWord = "别点啦！我也是有底线的~";
            this.flag = 1;
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    goBack() {
      this.params("", "", "goBack");
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    toInvest() {
      this.params("", "", "toInvest");
    },
  },
};
</script>

<style lang="less">
p {
  margin: 0;
}
.rank-list {
  background: #f2f2f2;
  color: #333;
  min-height: 100%;
  .rank-title {
    background: #feb483;
    padding-top: 24px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    .van-nav-bar__title {
      color: #fff;
      font-size: 18px;
    }
  }
  .rank-reback {
    width: 15px;
    padding: 12px 15px;
    position: fixed;
    top: 30px;
    left: 0;
    z-index: 2;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0 !important;
  }
  .rank-top {
    height: 240px;
    margin-top: 70px;
    position: relative;
    background: -webkit-linear-gradient(
      #feb483,
      #d07544
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#feb483, #d07544); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#feb483, #d07544); /* Firefox 3.6 - 15 */
    background: linear-gradient(
      #feb483,
      #d07544
    ); /* 标准的语法（必须放在最后） */
    .box {
      height: 162px;
      margin-top: 28px;
      background: url(../../assets/member/rankBg2.png) no-repeat center center;
      background-size: 100% 100%;
      .head-portrait {
        text-align: center;
        padding-top: 2px;
        height: 85px;
        overflow: hidden;
        position: relative;
        img {
          width: 45px;
        }
        .avatar {
          position: absolute;
          left: 0;
          bottom: 0;
          text-align: center;
          width: 100%;
          height: 45px;
          padding-bottom: 1px;
          img {
            width: 43px;
            height: 43px;
            border-radius: 50%;
          }
        }
      }
      .nickname {
        color: #aaa;
        font-size: 11px;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
      .number {
        color: #333;
        font-size: 15px;
        font-weight: 700;
        text-align: center;
        line-height: 21px;
      }
    }
    .rank-top-right {
      height: 146px;
      margin-top: 44px;
      background: url(../../assets/member/rankBg3.png) no-repeat center center;
      background-size: 100% 100%;
      .head-portrait {
        height: 72px;
      }
    }
    .rank-top-middle {
      height: 191px;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      .No1 {
        width: 37.5%;
        height: 185px;
        margin-top: 6px;
        margin-left: 31%;
        background: url(../../assets/member/rankBg1.png) no-repeat center center;
        background-size: 100% 100%;
        .head-portrait {
          height: 107px;
          img {
            width: 50px;
          }
          .avatar {
            height: 50px;
            img {
              width: 48px;
              height: 48px;
            }
          }
        }
      }
    }
    .tip {
      color: #fff;
      font-size: 12px;
      height: 50px;
      line-height: 12px;
      padding: 0 12px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .myRank {
      padding: 0 12px;
      position: absolute;
      left: 0;
      bottom: -56px;
      p {
        height: 75px;
        line-height: 75px;
        color: #333;
        font-size: 13px;
        font-weight: 700;
        border-radius: 10px;
        background: #fff;
        padding: 0 17px 0 20px;
        img {
          width: 45px;
          height: 45px;
          border-radius: 10px;
          float: left;
          margin-top: 15px;
          margin-right: 21px;
        }
        span {
          float: right;
          font-size: 18px;
        }
      }
    }
  }
  .fans-rank {
    padding: 60px 12px 50px;
    .title {
      color: #333;
      font-size: 18px;
      font-weight: 700;
      line-height: 50px;
    }
    .van-row {
      background: #fff;
      border-radius: 10px;
      padding: 0 10px;
      .van-col {
        color: #333;
        font-size: 13px;
        height: 64px;
        line-height: 64px;
        border-bottom: solid 1px #f2f2f2;
        span {
          float: right;
          font-size: 18px;
          padding-right: 9px;
        }
        .Ranking {
          font-size: 12px;
          float: left;
          width: 25px;
          text-align: center;
        }
        img {
          width: 45px;
          height: 45px;
          float: left;
          border-radius: 10px;
          margin: 10px 23px 0 0;
        }
      }
      .more {
        color: #666;
        font-size: 12px;
        text-align: center;
        height: 34px;
        line-height: 34px;
      }
    }
  }
  .Invitation {
    position: fixed;
    bottom: 0;
    background: #f2f2f2;
    height: 34px;
    padding: 6px 0;
    width: 100%;
    .van-col {
      padding: 0 12px;
      p {
        color: #fff;
        font-size: 14px;
        line-height: 34px;
        text-align: center;
        border-radius: 17px;
        background: -webkit-linear-gradient(
          #fec485,
          #de6624
        ); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(
          #fec485,
          #de6624
        ); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(
          #fec485,
          #de6624
        ); /* Firefox 3.6 - 15 */
        background: linear-gradient(
          #fec485,
          #de6624
        ); /* 标准的语法（必须放在最后） */
      }
    }
  }
}
.isiOSX {
  .rank-title {
    padding-top: 44px;
  }
  .rank-reback {
    top: 50px;
  }
  .rank-top {
    margin-top: 90px;
  }
}
</style>
